<template>
  <div class="playlist">
    <div v-for="(item, index) in list" :key="index" :class="{ video: player.index === index && player.video, audio: player.index === index && player.audio }">
      <a class="name" href="javascript:;" @click="onPlayVideo(index, true)">{{ item.title }}</a>
      <a href="javascript:;" class="icon icon-play-o" :class="{ off: !item.mp4 }" @click="onPlayVideo(index, false)"></a>
      <!-- <a href="javascript:;" class="icon icon-pdf" :class="{ off: !item.doc }" @click="onDownloadPdf(index)"></a> -->
      <a href="javascript:;" class="icon icon-music1" @click="onPlayAudio(index)"></a>
      <!-- <a href="javascript:;" class="icon icon-xiazaiyinpin" @click="onDownloadAudio(index)"></a> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    player: {}
  },
  computed: {
    list() {
      return this.$service.movie.movie.urls
    }
  },
  methods: {
    async onPlayVideo(index, auto) {
      if (await this.$service.user.checkUserState(this, false, true)) {
        this.$emit('video', { index, auto })
      }
    },
    async onPlayAudio(index) {
      if (await this.$service.user.checkUserState(this, false, true)) {
        this.$emit('audio', index)
      }
    },
    onDownloadAudio(index) {
      this.$emit('download-audio', index)
    },
    onDownloadPdf(index) {
      this.$emit('pdf', index)
    }
  }
}
</script>
<style scoped lang='scss'>
.playlist {
  background-color: $color-white;
  padding-left: $app-padding;

  >div {
    display: flex;
    align-items: center;
    min-height: 44px;
    border-bottom: $style-border;
    color: $primary-text-color;

    .name {
      flex: 1;
      font-size: 14px;
      line-height: 16px;
      margin: 4px 0;
    }

    .icon {
      width: 40px;
      text-align: center;
      font-size: 20px;
      color: $secondly-text-color;

      &.off {
        color: #cccccc;
      }
    }

    &.video {

      .name,
      .icon-play {
        color: $color-red;
      }
    }

    &.audio {

      .name,
      .icon-music1 {
        color: $color-red;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// PlayList.vue?5fdd59a9